// extracted by mini-css-extract-plugin
export default {"list":"table-of-contents_list__3P3zE typography_paragraphLarge__36ymP typography_bodyFont__1UNdB","listItem":"table-of-contents_listItem__17NTb"};